import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.scss';

export const BODY_SHADE_CLASS = 'se-modal-open';
const { body } = document;
const headerContainer = document.querySelector('.js-header-apc');

let openedWindowsCount = 0;

export class Popup extends Component {
    domNode = null;
    topWindowPosition = 0;

    static propTypes = {
        onClose: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.domNode = document.createElement('div');
        this.domNode.classList.add('se-theme');
        body.appendChild(this.domNode);
        this.topWindowPosition = window.scrollY;
    }

    componentDidMount() {
        const windowWidthWithTrack = body.offsetWidth;
        openedWindowsCount += 1;
        body.classList.add(BODY_SHADE_CLASS);
        const windowWidthWithoutTrack = body.offsetWidth;
        const trackWidth = windowWidthWithoutTrack - windowWidthWithTrack;
        body.style.top = `${-this.topWindowPosition}px`;
        body.style.paddingRight = `${trackWidth}px`;
        headerContainer.style.right = `${trackWidth}px`;
    }

    componentWillUnmount() {
        openedWindowsCount -= 1;
        if (openedWindowsCount === 0) {
            body.classList.remove(BODY_SHADE_CLASS);
            body.style.paddingRight = `${0}px`;
            headerContainer.style.right = '';
        }
        body.removeChild(this.domNode);
        window.scroll(0, this.topWindowPosition);
    }

    render() {
        const { children, onClose } = this.props;
        return createPortal(
            <div className={styles.modalWindow}>
                <div className={styles.modalBg} onClick={onClose} />
                <div className={styles.modalContent}>{children}</div>
            </div>,
            this.domNode,
        );
    }
}
